import { HandClapOffIcon } from './HandClapOffIcon';

/**
 * author: Michael Irigoyen
 * id 9B126394-E75C-416A-8959-F76B5FE2A5E0
 * name hand-clap-off
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/hand-clap-off.svg
 * tags
 */
export const ApplauseOffIcon = HandClapOffIcon;
export default ApplauseOffIcon